// extracted by mini-css-extract-plugin
module.exports = {"MapMenu":"mapMenu_MapMenu__SlRLe","datasets_label":"mapMenu_datasets_label__95bwH","datasets_styledCheckbox":"mapMenu_datasets_styledCheckbox__Z5RUL"};